import { ROUTES } from 'constants/Routes';

export const NAVROUTES = {
  SURVEY_TEMPLATE: [
    ROUTES.SURVEY_TEMPLATE_INDEX,
    ROUTES.ADD_NEW_SURVEY_TEMPLATE,
    ROUTES.EDIT_SURVEY_TEMPLATE,
    ROUTES.QUESTION_INDEX,
    ROUTES.CATEGORIES_QUESTIONS,
  ],
  QUESTION: [ROUTES.QUESTION_INDEX, ROUTES.CATEGORIES_QUESTIONS],
  BUSINESS: [
    ROUTES.BUSINESS_INDEX,
    ROUTES.ADD_NEW_BUSINESS,
    ROUTES.EDIT_BUSINESS_BASIC_INFO,
    ROUTES.REQUEST_BUSINESS_ADD_ONS,
    ROUTES.BUSINESS_FILTER,
    ROUTES.CUSTOM_SURVEY_LIST,
    ROUTES.CUSTOM_SURVEY_ADD,
    ROUTES.CUSTOM_SURVEY_EDIT,
    ROUTES.QUESTION_LIST,
    ROUTES.CUSTOM_QUESTION_LIST,
    ROUTES.CUSTOM_SURVEY_QUESTIONS,
    ROUTES.REPORT_LIST,
    ROUTES.CUSTOM_REPORT_LIST,
    ROUTES.CUSTOM_SURVEY_REPORTS,
    ROUTES.USERS_LIST,
    ROUTES.USER_EDIT,
    ROUTES.USER_NEW,
    ROUTES.BUSINESS_USER_INVITATION_NEW,
    ROUTES.REWARD_ISSUED,
    ROUTES.REWARD_REDEEMED,
    ROUTES.BUSINESS_CATEGORY_FILTER,
    ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG,
    ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG,
    ROUTES.BUSINESS_SURVEY_FEEDBACKS,
    ROUTES.CUSTOM_SURVEY_FEEDBACKS,
    ROUTES.BUSINESS_SMS_ALERT_CONFIG,
  ],
  DASHBOARD: [
    ROUTES.DASHBOARD_INDEX,
    ROUTES.REPORT_INDEX,
    ROUTES.CATEGORY_REPORTS,
  ],
  REPORT: [ROUTES.REPORT_INDEX, ROUTES.CATEGORY_REPORTS],
};

export const BUSINESS_ADMIN_NAV = {
  DASHBOARD: [
    ROUTES.BUSINESS_DASHBOARD_INDEX,
    ROUTES.REPORT_LIST,
    ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG,
    ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG,
    ROUTES.BUSINESS_SMS_ALERT_CONFIG,
    ROUTES.CUSTOM_REPORT_LIST,
    ROUTES.CUSTOM_SURVEY_REPORTS,
    ROUTES.BUSINESS_SURVEY_FEEDBACKS,
    ROUTES.CUSTOM_SURVEY_FEEDBACKS,
  ],
  CUSTOM_SURVEY: [
    ROUTES.CUSTOM_SURVEY_LIST,
    ROUTES.CUSTOM_SURVEY_ADD,
    ROUTES.CUSTOM_SURVEY_EDIT,
  ],
  SURVEY: [
    ROUTES.QUESTION_LIST,
    ROUTES.CUSTOM_QUESTION_LIST,
    ROUTES.CUSTOM_SURVEY_QUESTIONS,
  ],
  REPORT: [
    ROUTES.REPORT_LIST,
    ROUTES.CUSTOM_REPORT_LIST,
    ROUTES.CUSTOM_SURVEY_REPORTS,
  ],
  FEEDBACK_REPORT: [
    ROUTES.BUSINESS_SURVEY_FEEDBACKS,
    ROUTES.CUSTOM_SURVEY_FEEDBACKS,
  ],
  USER: [
    ROUTES.USERS_LIST,
    ROUTES.USER_EDIT,
    ROUTES.USER_NEW,
    ROUTES.BUSINESS_USER_INVITATION_NEW,
    ROUTES.BUSINESS_USER_DETAIL,
  ],
  REDEEM: [ROUTES.REWARD_ISSUED, ROUTES.REWARD_REDEEMED],
  MEASURES: [ROUTES.MEASURES_OF_SUCCESS],
};



// WEBPACK FOOTER //
// ./src/constants/NavRoutes.js